import styled from 'styled-components';
import {
  CardInput,
  CardRow,
  CardSection,
  CardsList,
  CheckboxContainer,
  InfoCardMiniSpan,
} from '../../components/CardInputs/CardsStyledComponents';
import { PromotionCard } from '../Entry/EntryStyledComponents';

export const CardValues = styled.div``;

export const CardAmountInfoSection = styled(CardSection)`
  margin-top: 8px;
`;

export const SavedInfoText = styled(InfoCardMiniSpan)`
  @media (max-width: 650px) {
    display: none;
  }
`;

export const MobileSavedInfoText = styled(InfoCardMiniSpan)`
  display: none;

  @media (max-width: 650px) {
    display: flex;
  }
`;

export const CardInputCustomAmount = styled(CardInput)`
  flex-direction: column;
  width: 100%;
  padding: 0;
`;

export const CardInputPaymentPlan = styled(CardInput)`
  flex-direction: column;
  width: 100%;
  padding: 0;
  display: block;
`;

export const CardInputCustomPayment = styled(CardInput)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
`;

interface CardCustomPaymentSectionProps {
  $isSelected: boolean;
}

export const CardCustomPaymentSection = styled(
  CardSection
)<CardCustomPaymentSectionProps>`
  gap: 10px;
  padding: ${(props) => (props.$isSelected ? '24px 24px 0' : '24px')};

  @media (max-width: 650px) {
    padding: 15px;
  }
`;

export const CoCardsList = styled(CardsList)`
  margin-bottom: 8px;
`;

export const CustomAmountTitle = styled.span``;

export const CustomAmountSubtitle = styled.span``;

export const CoPromotionCard = styled(PromotionCard)`
  padding-bottom: 0px;

  @media (max-width: 650px) {
    padding-right: 0px;
    padding-left: 0px;
  }
`;

export const MiniSpanContainer = styled.div`
  padding-right: 20px;
  bottom: 40px;
  position: relative;

  @media (max-width: 950px) and (min-width: 850px) {
    padding-right: 20px;
    bottom: 50px;
  }
  @media (max-width: 650px) {
    padding-right: 20px;
    padding-bottom: 20px;
    bottom: 0px;
  }
`;

export const LoanCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;

export const CoCheckboxContainer = styled(CheckboxContainer)`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 44px;
`;

export const CardPaymentRow = styled(CardRow)`
  @media (max-width: 420px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;
